// Types.
import {
  APP_MAINTENANCE_LOADING,
  APP_MAINTENANCE_ERROR,
  APP_MAINTENANCE_SUCCESS,
  GET_COMISSIONS_ERROR,
  GET_COMISSIONS_LOADING,
  GET_COMISSIONS_SUCCESS,
  CLEAN_STATE,
  POST_PAYMENT_LOADING,
  POST_PAYMENT_ERROR,
  POST_PAYMENT_SUCCESS,
  GET_CVV_ERROR,
  GET_CVV_LOADING,
  GET_CVV_SUCCESS,
  GET_CAPTURE_LINE_DATA_LOADING,
  GET_CAPTURE_LINE_DATA_SUCCESS,
  GET_CAPTURE_LINE_DATA_ERROR,
  PAYMENT_SERVICE_ERROR,
  PAYMENT_SERVICE_LOADING,
  PAYMENT_SERVICE_SUCCESS,
  VERIFY_PAYMENT_SERVICE_LOADING,
  VERIFY_PAYMENT_SERVICE_ERROR,
  VERIFY_PAYMENT_SERVICE_SUCCESS,
  VALIDATE_TRANSACTION_LOADING,
  VALIDATE_TRANSACTION_ERROR,
  VALIDATE_TRANSACTION_SUCCESS,
  AUTHENTICATION_3DS_LOADING,
  AUTHENTICATION_3DS_ERROR,
  AUTHENTICATION_3DS_SUCCESS,
  STATE_AUTHENTICATION_3DS_LOADING,
  STATE_AUTHENTICATION_3DS_ERROR,
  STATE_AUTHENTICATION_3DS_SUCCESS,
  CDMX_STATUS_PAYMENT_LOADING,
  CDMX_STATUS_PAYMENT_ERROR,
  CDMX_STATUS_PAYMENT_SUCCESS,
  GET_CDMX_PAGE_LOADING,
  GET_CDMX_PAGE_ERROR,
  GET_CDMX_PAGE_SUCCESS,
  POST_CHECKOUT_LOADING,
  POST_CHECKOUT_ERROR,
  POST_CHECKOUT_SUCCESS,
  UPDATE_PENDING_TRANSACTION_LOADING,
  UPDATE_PENDING_TRANSACTION_ERROR,
  UPDATE_PENDING_TRANSACTION_SUCCESS,
  VALIDATE_CDMX_DATA_LOADING,
  VALIDATE_CDMX_DATA_ERROR,
  VALIDATE_CDMX_DATA_SUCCESS,
} from "./transaction.types";

/**
 * Object to manage the initial state for lead reducer.
 * {Object} apiActions manage the state for the endpoint.
 */
const INITIAL_STATE = {
  apiActions: {
    loading: false,
    error: "",
    errorCheckout: "",
    success: "",
    successVerify: "",
  },
  isMaintenance: null,
  comissions: null,
  cvv: null,
  validation: null,
  authentication3ds: null,
  stateAuthentication3ds: null,
  cdmxStatusPayment: null,
  getCdmxPage: null,
  checkout: null,
  updatedPendingTransaction: null,
  cdmxValidationData: null,
};

/**
 * Manage the initial state for lead reducer.
 * @param  {Object} state is the initial state for the reducer.
 * @param {string} type action to take.
 * @param {Object} payload response for a action.
 */
const transactionReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case CLEAN_STATE: // when the update endpoint is being called.
      return {
        ...state,
        apiActions: {
          loading: false,
          error: "",
          errorCheckout: "",
          success: "",
          errorCaptureLine: "",
        },
        comissions: null,
        cvv: null,
        validation: null,
        authentication3ds: null,
        checkout: null,
        stateAuthentication3ds: null,
        cdmxStatusPayment: null,
        getCdmxPage: null,
      };
    case APP_MAINTENANCE_LOADING: // when the update endpoint is being called.
      return {
        ...state,
        apiActions: {
          loading: true,
          error: "",
          success: "",
        },
      };

    case APP_MAINTENANCE_ERROR: // when the update endpoint returns an error.
      return {
        ...state,
        apiActions: {
          loading: false,
          error: payload,
          success: "",
        },
      };
    case APP_MAINTENANCE_SUCCESS:
      return {
        ...state,
        apiActions: {
          loading: false,
          error: "",
          success: "",
        },
        isMaintenance: payload,
      };
    case GET_COMISSIONS_LOADING:
      return {
        ...state,
        apiActions: {
          loading: true,
          error: "",
          success: "",
        },
      };

    case GET_COMISSIONS_ERROR: // when the update endpoint returns an error.
      return {
        ...state,
        apiActions: {
          loading: false,
          error: payload,
          success: "",
        },
      };
    case GET_COMISSIONS_SUCCESS:
      return {
        ...state,
        apiActions: {
          loading: false,
          error: "",
          success: "",
        },
        comissions: payload,
      };
    case VERIFY_PAYMENT_SERVICE_LOADING:
      return {
        ...state,
        apiActions: {
          loading: true,
          error: "",
          success: "",
        },
      };

    case VERIFY_PAYMENT_SERVICE_ERROR: // when the update endpoint returns an error.
      return {
        ...state,
        apiActions: {
          loading: false,
          error: "",
          errorVerify: payload,
          success: "",
        },
      };
    case VERIFY_PAYMENT_SERVICE_SUCCESS:
      return {
        ...state,
        apiActions: {
          loading: false,
          error: "",
          success: "",
          successVerify: payload,
        },
      };
    case POST_PAYMENT_LOADING:
    case GET_CAPTURE_LINE_DATA_LOADING:
      return {
        ...state,
        apiActions: {
          loading: true,
          error: "",
          success: "",
          errorCaptureLine: "",
        },
      };
    case GET_CAPTURE_LINE_DATA_SUCCESS: // when the update endpoint returns an error.
    case GET_CAPTURE_LINE_DATA_ERROR: // when the update endpoint returns an error.
      return {
        ...state,
        apiActions: {
          loading: false,
          errorCaptureLine:
            GET_CAPTURE_LINE_DATA_SUCCESS === type ? "" : payload,
          ...state.apiActions,
        },
        captureLineData: GET_CAPTURE_LINE_DATA_SUCCESS === type ? payload : "",
      };
    case POST_PAYMENT_ERROR: // when the update endpoint returns an error.
      return {
        ...state,
        apiActions: {
          loading: false,
          error: payload,
          success: "",
        },
      };
    case POST_PAYMENT_SUCCESS:
      return {
        ...state,
        apiActions: {
          loading: false,
          error: "",
          success: payload,
        },
      };
    case GET_CVV_LOADING:
      return {
        ...state,
        apiActions: {
          loading: true,
          error: "",
          success: "",
        },
      };

    case GET_CVV_ERROR: // when the update endpoint returns an error.
      return {
        ...state,
        apiActions: {
          loading: false,
          error: payload,
          success: "",
        },
      };
    case GET_CVV_SUCCESS:
      return {
        ...state,
        apiActions: {
          loading: false,
          error: "",
          success: "",
        },
        cvv: payload,
      };
    case POST_CHECKOUT_LOADING:
      return {
        ...state,
        apiActions: {
          loading: true,
          error: "",
          success: "",
        },
      };

    case POST_CHECKOUT_ERROR: // when the update endpoint returns an error.
      return {
        ...state,
        apiActions: {
          loading: false,
          errorCheckout: payload,
          success: "",
        },
      };
    case POST_CHECKOUT_SUCCESS:
      return {
        ...state,
        apiActions: {
          loading: false,
          error: "",
          success: "",
        },
        checkout: payload,
      };
    case VALIDATE_TRANSACTION_LOADING:
      return {
        ...state,
        apiActions: {
          loading: true,
          error: "",
          success: "",
        },
      };

    case VALIDATE_TRANSACTION_ERROR: // when the update endpoint returns an error.
      return {
        ...state,
        apiActions: {
          loading: false,
          error: payload,
          success: "",
        },
      };
    case VALIDATE_TRANSACTION_SUCCESS:
      return {
        ...state,
        apiActions: {
          loading: false,
          error: "",
          success: "",
        },
        validation: payload,
      };
    case AUTHENTICATION_3DS_LOADING:
      return {
        ...state,
        apiActions: {
          loading: true,
          error: "",
          success: "",
        },
      };

    case AUTHENTICATION_3DS_ERROR: // when the update endpoint returns an error.
      return {
        ...state,
        apiActions: {
          loading: false,
          error: payload,
          success: "",
        },
      };
    case AUTHENTICATION_3DS_SUCCESS:
      return {
        ...state,
        apiActions: {
          loading: false,
          error: "",
          success: "",
        },
        authentication3ds: payload,
      };
    case STATE_AUTHENTICATION_3DS_LOADING:
      return {
        ...state,
        apiActions: {
          loading: true,
          error: "",
          success: "",
        },
      };

    case STATE_AUTHENTICATION_3DS_ERROR: // when the update endpoint returns an error.
      return {
        ...state,
        apiActions: {
          loading: false,
          error: payload,
          success: "",
        },
      };
    case STATE_AUTHENTICATION_3DS_SUCCESS:
      return {
        ...state,
        apiActions: {
          loading: false,
          error: "",
          success: "",
        },
        stateAuthentication3ds: payload,
      };
    case CDMX_STATUS_PAYMENT_LOADING:
      return {
        ...state,
        apiActions: {
          loading: true,
          error: "",
          success: "",
        },
      };

    case CDMX_STATUS_PAYMENT_ERROR: // when the update endpoint returns an error.
      return {
        ...state,
        apiActions: {
          loading: false,
          error: payload,
          success: "",
        },
      };
    case CDMX_STATUS_PAYMENT_SUCCESS:
      return {
        ...state,
        apiActions: {
          loading: false,
          error: "",
          success: "",
        },
        cdmxStatusPayment: payload,
      };
    case GET_CDMX_PAGE_LOADING:
      return {
        ...state,
        apiActions: {
          loading: true,
          error: "",
          success: "",
        },
      };

    case GET_CDMX_PAGE_ERROR: // when the update endpoint returns an error.
      return {
        ...state,
        apiActions: {
          loading: false,
          error: payload,
          success: "",
        },
      };
    case GET_CDMX_PAGE_SUCCESS:
      return {
        ...state,
        apiActions: {
          loading: false,
          error: "",
          success: "",
        },
        getCdmxPage: payload,
      };
    case PAYMENT_SERVICE_ERROR: // when the update endpoint returns an error.
      return {
        ...state,
        apiActions: {
          loading: false,
          error: payload,
          success: "",
        },
      };
    case PAYMENT_SERVICE_SUCCESS:
      return {
        ...state,
        apiActions: {
          loading: false,
          error: "",
          success: payload,
        },
      };
    case PAYMENT_SERVICE_LOADING:
      return {
        ...state,
        apiActions: {
          loading: true,
          error: "",
          success: "",
        },
      };
    case UPDATE_PENDING_TRANSACTION_LOADING:
      return {
        ...state,
        apiActions: {
          loading: true,
          error: "",
          success: "",
        },
      };
    case UPDATE_PENDING_TRANSACTION_ERROR:
      return {
        ...state,
        apiActions: {
          loading: false,
          error: payload,
          success: "",
        },
      };
    case UPDATE_PENDING_TRANSACTION_SUCCESS:
      return {
        ...state,
        apiActions: {
          loading: false,
          error: "",
          success: "",
        },
        updatedPendingTransaction: payload,
      };
    case VALIDATE_CDMX_DATA_LOADING:
      return {
        ...state,
        apiActions: {
          loading: true,
          error: "",
          success: "",
        },
      };
    case VALIDATE_CDMX_DATA_ERROR:
      return {
        ...state,
        apiActions: {
          loading: false,
          error: payload,
          success: "",
        },
      };
    case VALIDATE_CDMX_DATA_SUCCESS:
      return {
        ...state,
        apiActions: {
          loading: false,
          error: "",
          success: "",
        },
        cdmxValidationData: payload,
      };
    default:
      return { ...state };
  }
};

export default transactionReducer;
